import { Grid, Typography } from "@mui/material";

type ShowNamesUserProps = {
  title: string;
  icon: React.ReactNode;
  user: string;
  texto?: string
};

const ShowNamesUser = ({ title, icon, user, texto }: ShowNamesUserProps) => {
  return (
    <Grid container spacing={1}>
      <Grid item>

        <Grid
          container
          direction="column"
          alignItems="center"
        /* sx={{
          p: 1.5,
          borderRadius: 2,
          border: "1px solid #e0e0e0",
          backgroundColor: "#fafafa",
          width: "200px",
          textAlign: "center",
        }} */
        >

          <Grid item>
            {/* <Typography
              variant="subtitle2"
              color="text.secondary"
              sx={{ fontWeight: 600, mb: 1 }}
            >
              {title}
            </Typography> */}

          </Grid>


          {/* ICONO + TEXTO JUNTOS */}
          <Grid item>
            <Typography variant="subtitle2" color={'text.secondary'}>{title}</Typography>
            <Grid container alignItems="center" justifyContent="center" spacing={1}>
              <Grid item>
                {icon}
              </Grid>
              <Grid item>
                <Typography
                  variant="body2"
                  fontWeight={500}
                  color="text.primary"
                >
                  {`${texto ||'Creado por'}: ${user}`}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

        </Grid>

      </Grid>
    </Grid>
  );
};

export default ShowNamesUser;
